const zhCN = {
  meta: { code: "zh-CN", label: "简体中文" },
  nav: {
    brand: "IQ Log",
    diagnostics: "测评",
    mypage: "我的主页",
    login: "登录",
    register: "注册",
    logout: "退出",
  },
  hero: {
    eyebrow: "测评平台",
    title: "通过测评发现你的本质",
    subtitle1: "思维、性格与天赋——完全可视化",
    subtitle2: "5 分钟看清你的优势与短板",
    subtitle3: "每一次测评都成为你的数据",
    cta_primary: "开始测评",
    cta_secondary: "浏览目录",
    disclaimer: "参考信息 / 非医疗",
  },
  categories: {
    ability: "能力",
    personality: "性格",
    mental: "心理",
    aptitude: "适性",
    traits: "特质",
  },
  catalog: {
    title: "全部测评",
    subtitle: "17 项测评 / 5 大类别",
    filter_all: "全部",
    duration: "分钟",
    difficulty: { easy: "简单", medium: "中等", hard: "困难" },
    question_count: "题",
    start: "开始",
  },
  quiz: {
    question: "题目",
    of: "/",
    next: "下一题",
    prev: "上一题",
    submit: "查看结果",
    progress: "进度",
    exit: "退出",
    required: "请选择一个选项",
    submitting: "评分中…",
  },
  result: {
    overall: "综合得分",
    type_label: "类型",
    share_link: "通过链接分享结果",
    back_to_catalog: "做其他测评",
    view_mypage: "在我的主页查看历史",
    premium_title: "解锁详细分析",
    premium_subtitle: "高级版可查看以下全部内容:",
    feature_breakdown: "详细得分拆解",
    feature_cause: "根因分析",
    feature_plan: "改进计划",
    feature_pdf: "PDF 报告(A4)",
    price: "¥980",
    price_note: "(通过 Stripe 安全结账)",
    price_free: "免费",
    price_free_note: "(限时 · 100% 免费)",
    unlock_button: "用 Stripe 支付",
    unlock_button_free: "免费解锁",
    unlock_requires_auth: "请登录后解锁",
    unlock_save_first: "请先用账户保存结果",
    unlocking: "正在跳转到 Stripe…",
    free_only_notice: "免费版仅显示综合得分和类型。",
    compliance_note: "本测评仅供参考,不属于医疗诊断。我们避免使用断定性或制造焦虑的措辞。",
  },
  premium: {
    title: "详细分析报告",
    summary: "整体概要",
    strengths: "优势",
    weaknesses: "成长空间",
    improvements: "改进计划",
    dimensions: "维度得分",
    download_pdf: "下载 PDF",
    pdf_soon: "PDF 导出(即将推出)",
  },
  mypage: {
    title: "我的主页",
    subtitle: "你的历史、得分趋势与徽章",
    total: "测评总数",
    average: "平均得分",
    premium_count: "已解锁",
    categories_covered: "覆盖类别",
    trend_title: "得分趋势",
    history_title: "历史记录",
    badges_title: "徽章",
    unlock_3_title: "解锁综合分析",
    unlock_3_desc: "再做 {n} 次测评即可解锁综合分析",
    unlocked: "综合分析已解锁",
    no_history: "尚无测评——立即开始你的第一次。",
  },
  auth: {
    login_title: "登录",
    register_title: "创建账户",
    email: "邮箱",
    password: "密码(至少 6 位)",
    name: "显示名称(可选)",
    login_btn: "登录",
    register_btn: "注册",
    go_register: "没有账户?注册",
    go_login: "已有账户?登录",
    anon_note: "测评免费且匿名。仅在保存结果或解锁高级时需要账户。",
    success_register: "账户已创建",
    success_login: "已登录",
    consent_section: "同意事项",
    consent_required: "请同意必填项",
    accept_terms_pre: "我同意",
    terms_link: "服务条款",
    accept_terms_post: "",
    accept_privacy_pre: "我已阅读",
    privacy_link: "隐私政策",
    accept_privacy_post: ",并同意处理我的个人数据",
    accept_age: "我已满 16 岁(或已获得监护人同意)",
    accept_marketing: "向我发送新测评和促销邮件",
    optional: "可选",
  },
  landing: {
    status_online: "系统在线",
    status_subtitle: "诊断 OS v2.0",
    status_tests: "17 项测评",
    status_langs: "14 种语言",
    status_ai: "AI · 已启用",
    title_line1: "通过测评发现",
    title_line2: "你的本质。",
    trust_diagnostics: "测评",
    trust_languages: "语言",
    trust_per_test: "每项",
    hud_readout: "主要读数",
    hud_score_unit: "/100 综合",
    hud_band: "等级 · GOLD",
    hud_dimensions: "维度",
    hud_dimensions_status: "3 / 3 活跃",
    hud_syslog: "系统日志",
    cat_eyebrow: "// 类别",
    cat_title_pre: "5 大类 · ",
    cat_title_highlight: "17 项测评",
    view_all: "查看全部",
    proto_eyebrow: "// 流程",
    proto_title_pre: "用 3 步 ",
    proto_title_highlight: "解锁本质。",
    step1_title: "选择测评",
    step1_body: "从 17 种中选择,可匿名开始。",
    step2_title: "5 分钟作答",
    step2_body: "进度条与徽章助你前行。",
    step3_title: "AI 解锁",
    step3_body: "详细分数、计划与 PDF。",
    final_eyebrow: "// 准备好了吗?",
    final_title_pre: "你的本质 ",
    final_title_highlight: "5 分钟见分晓。",
    final_subtitle: "5 分钟看清你的优势与短板",
    final_button: "立即开始测评",
  },
  footer: {
    tagline: "记录你的思维、性格与适性的测评平台",
    rights: "保留所有权利。",
    legal: "法律",
    privacy: "隐私",
    terms: "条款",
    about_label: "关于 / 公司",
    compliance_label: "国际合规",
    tokushoho_label: "日本特商法表记",
    data_protection_label: "数据保护(国际版)",
    data_request_label: "数据删除 / 退出申请",
    disclaimer_label: "免责声明",
    disclaimer_full: "本服务仅供参考,不属于医疗诊断。我们不使用断定性或制造焦虑的措辞。",
  },
  badges: {
    "first-diagnosis": "首次测评",
    "three-diagnostics": "3 次测评",
    "five-diagnostics": "5 次测评",
    "ten-diagnostics": "10 次测评",
    "high-performer": "高分用户",
    "premium-user": "高级用户",
  },
  lang_selector: "语言",
  payment: {
    processing_title: "正在确认支付…",
    processing_subtitle: "已从 Stripe 返回——正在生成详细分析(最多 20 秒)",
    success: "支付已确认——高级已解锁",
    expired: "结账会话已过期,请重试。",
    error: "无法确认支付,请联系客服。",
  },
};
export default zhCN;
